<template>
  <DefaultButton
    :disabled="
      disabled ||
      configuratorStore.hasMediaclipError ||
      configuratorStore.buttonsOnCooldown ||
      configuratorStore.isUpdatingProject
    "
    :loading="buttonLoading"
    data-testid="add-to-cart-button"
    class="h-full"
    @click="
      addToCart.addConfiguratorProductToCart(
        sizeStore.selectedSizeValue.attributes.sku,
        sizeStore.selectedSizeValue.attributes.mediaclipProductId
      )
    "
  >
    <template #icon>
      <CartIcon class="h-7 w-7" />
    </template>

    <template #default>
      {{
        $t(
          configuratorStore.quoteItemId
            ? 'pages.extra_options.update_cart'
            : 'pages.extra_options.add_to_cart'
        )
      }}
    </template>
  </DefaultButton>

  <FullPageLoader v-if="showLoader" :current-step="currentStep" />
</template>

<script setup lang="ts">
import CartIcon from '@/components/Icons/CartIcon.vue';
import FullPageLoader from '@/components/States/FullPageLoader.vue';
import { useAddToCart } from '@/composables/UseAddToCart';
import i18n from '@/i18n';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { useSizeStore } from '@/stores/Configurator/SizeStore';
import { computed } from 'vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';

const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const sizeStore = useSizeStore();
const configuratorStore = useConfiguratorStore();

const addToCart = useAddToCart();

const buttonLoading = computed(
  () =>
    props.loading ||
    addToCart.isAwaitingRedirect.value ||
    addToCart.addConfiguratorProductToCartRequest.isLoading ||
    addToCart.updateRequest.isLoading
);

const showLoader = computed(
  () => addToCart.isAwaitingRedirect.value || addToCart.isRequesting.value
);

const currentStep = computed(() => {
  if (addToCart.isAwaitingRedirect.value) {
    return i18n.global.t('loader.currentstep.redirecting_to_cart');
  }

  return configuratorStore.quoteItemId
    ? i18n.global.t('loader.currentstep.updating_cart')
    : i18n.global.t('loader.currentstep.adding_to_cart');
});
</script>
